/** Preview */

'use strict'

$(document).ready(function () {
  /** Render Iframes */
  const iframes = {
    vars: {
      selectors: {
        wrapper: '.js-page-preview[data-src]'
      },
    },
    init: (target = null) => {
      $(document).find(target || iframes.vars.selectors.wrapper).each((_, el) => {
        let src = $(el).data('src')
        let screenWidth = 1440 // $(window).width() // Enable responsive iframe
        let wrapperWidth = $(el).width()
        let wrapperHeight = $(el).height()
        let iframe = {
          width: screenWidth,
          height: ((wrapperHeight / wrapperWidth) * screenWidth)
        }

        $(el).html(`<iframe src="${src}" width="${iframe.width}" height="${iframe.height}" loading="lazy" frameborder="0" style="position: absolute; top: 0; left: 0; width: ${iframe.width}px; height: ${iframe.height}px; transform-origin: 0 0; transform: scale(${wrapperWidth / screenWidth});"></iframe>`)
      })
    }
  }

  $(window).on('resize', function () {
    iframes.init()
  })

  iframes.init()
})